import { I18nUtils } from '../../../../i18n/I18nUtils';

export class Name {
    _name;

    constructor(name) {
        if ( !name )
            throw new Error(I18nUtils.tr('TR_CAMPO_OBLIGATORIO'));

        this._name = name;
    }

    get name() {
        return this._name;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/objectvalue/Name.js